/**
 * press-filter.js — 媒体页报道卡片分类过滤(原生,非滚动驱动)。
 *
 * 标记:[data-press-filter] 标签组 · .press-filter__tab[data-filter] · [data-press-grid] 卡片网格 ·
 *       .press-grid__item[data-category]。
 * 行为:点击标签 → 高亮 + 仅显示匹配分类的卡片(all 全显)。视觉过渡由 components.css。
 */
(function () {
  function initFilter(bar) {
    if (bar.dataset.pressFilterReady === '1') return;
    bar.dataset.pressFilterReady = '1';
    const tabs = Array.from(bar.querySelectorAll('.press-filter__tab'));
    const grid = document.querySelector('[data-press-grid]');
    if (!tabs.length || !grid) return;
    // 可过滤项 = featured 引用卡(被精选的同类内容)+ 网格卡片,都按 data-category 筛选
    const section = bar.closest('[data-component="press-coverage"]') || document;
    const items = Array.from(section.querySelectorAll('.press-quote[data-category], .press-grid__item[data-category]'));

    function apply(value) {
      items.forEach((it) => {
        const show = value === 'all' || it.dataset.category === value;
        it.classList.toggle('is-hidden', !show);
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        apply(tab.dataset.filter || 'all');
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-press-filter]').forEach(initFilter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
